// extracted by mini-css-extract-plugin
export default {"content":"Navigation_content__Vsmr+","btn":"Navigation_btn__VHQHA","btn_icon":"Navigation_btn_icon__0sV5e","path":"Navigation_path__e-w0l"};